import { render, staticRenderFns } from "./PlanningPage.vue?vue&type=template&id=87ea3e2e&scoped=true&lang=pug&"
import script from "./PlanningPage.vue?vue&type=script&lang=ts&"
export * from "./PlanningPage.vue?vue&type=script&lang=ts&"
import style0 from "./PlanningPage.vue?vue&type=style&index=0&id=87ea3e2e&lang=stylus&scoped=true&"
import style1 from "./PlanningPage.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87ea3e2e",
  null
  
)

export default component.exports